import React from "react";
import {
  Container,
  Typography,
  IconButton,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Question from "./Questions/Question";

import { useState, useEffect } from "react";
import axios from "axios";
import { fetchAssignmentAction } from "../../actions/fetchAssignment";
import { useSetAssignment } from "../../globals/AssignmentContext";
import { Box } from "@mui/system";
import { removeAssignmentAction } from "../../actions/removeAssignment";
import { useSetUser, useUser } from "../../globals/UserContext";
import { useSetClass } from "../../globals/ClassContext";
import { deleteAssignmentAction } from "../../actions/deleteAssignment";
import { useSetQuestion } from "../../globals/QuestionContext";
const { REACT_APP_DEBUGGER_SERVER_URL } = process.env;

export default function Assignment(props) {
  const user = useUser();
  const setUser = useSetUser();
  const setClass = useSetClass();
  const setQuestion = useSetQuestion();

  const [singleAssignment, setSingleAssignment] = useState({});
  const setAssignment = useSetAssignment();

  const { assignmentID } = props;
  const { setPage } = props;
  const { classID } = props;
  const { setConfirmationEffect } = props;
  const { setConfirmationText } = props;
  const { handleConfirmationOpen } = props;

  let dueDateText;

  if (
    singleAssignment?.due_date !== null &&
    typeof singleAssignment?.due_date !== "undefined"
  ) {
    const dueDate = new Date(singleAssignment?.due_date);
    const day = dueDate.getDate();
    const month = dueDate.toLocaleString("default", { month: "long" });
    //const year = dueDate.getFullYear()
    dueDateText = "Due " + month + " " + day;
  } else {
    dueDateText = "";
  }

  useEffect(() => {
    async function getAssignment() {
      const res = await axios
        .get(`${REACT_APP_DEBUGGER_SERVER_URL}/assignment/` + assignmentID)
        .catch((error) => {
          console.log(error);
        });
      setSingleAssignment(res.data);
    }
    getAssignment();
  }, [assignmentID]);

  const handleEdit = (event) => {
    fetchAssignmentAction(assignmentID, setAssignment, setQuestion);
    setPage("assignmentEditor");
    event.stopPropagation();
  };

  // The removal button serves for the deletion of an assignment or for its removal from a class
  // We also stop event propogation to prevent the accordion from expanding
  const handleRemove = (event) => {
    // Setting a state to a function must be done with an argument-less anonymous function to work
    if (typeof classID === "undefined") {
      setConfirmationText(
        <span>
          <b>Permanently delete</b> this assignment? This cannot be undone.
        </span>
      );
      setConfirmationEffect(() => deleteAssignment);
    } else {
      setConfirmationText(
        "Would you like to remove " +
          singleAssignment.name +
          " from this classroom?"
      );
      setConfirmationEffect(() => removeAssignment);
    }
    handleConfirmationOpen();
    event.stopPropagation();
  };

  const deleteAssignment = () => {
    deleteAssignmentAction(user._id, assignmentID, setUser);
  };

  const removeAssignment = () => {
    removeAssignmentAction(classID, assignmentID, setClass);
  };

  if (
    singleAssignment !== null &&
    typeof singleAssignment !== "undefined" &&
    Object.keys(singleAssignment).length !== 0
  ) {
    return (
      <Container
        key={assignmentID}
        component="main"
        maxWidth="sm"
        sx={{ paddingTop: "4px" }}
      >
        <Accordion elevation={3}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              display: "flex",
              "& .MuiAccordionSummary-contentGutters": { margin: "0px" },
            }}
          >
            <Grid
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                flex: "auto",
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  margin: "5px 0px",
                }}
              >
                {singleAssignment.name}
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography variant="subtitle2" sx={{ margin: "5px 0px" }}>
                  {dueDateText}
                </Typography>
                <IconButton
                  color="primary"
                  arialabel="remove"
                  onClick={handleRemove}
                >
                  {typeof classID === "undefined" ? (
                    <DeleteIcon />
                  ) : (
                    <RemoveCircleIcon />
                  )}
                </IconButton>
                <IconButton
                  color="primary"
                  arialabel="edit"
                  onClick={handleEdit}
                >
                  <EditIcon />
                </IconButton>
              </Box>
            </Grid>
          </AccordionSummary>
          <AccordionDetails sx={{ bgcolor: "lightgrey" }}>
            <Typography
              variant="subtitle1"
              sx={{ margin: "5px 0px", fontSize: "1.1rem" }}
            >
              Questions
            </Typography>
            {singleAssignment.questions?.map((questionID, questionNumber) => (
              <Question
                key={questionID}
                questionID={questionID}
                questionNumber={questionNumber + 1}
              ></Question>
            ))}
          </AccordionDetails>
        </Accordion>
      </Container>
    );
  } else {
  }
}
